import React, { Component } from 'react'
import './style.css'
export class News_item extends Component {
    render() {
    let props = this.props;
    return (
      <div>
        <>
        <div className={`card ${props.mode==='sun'?'bg-white':'bg-black'}`}>
            <img src={props.data.urlToImage} className="card-img" alt="..." />
            <div className={`card-body ${props.mode==='sun'?'text-black':'text-white'}`}>
                <h5 className="card-title">{props.data.title}</h5>
                <p className="card-text overflow-hidden">{props.data.description}</p>
                <a rel="noreferrer" href={props.data.url} target="_blank" className={`btn btn-${props.mode==='sun'?'primary':'danger'} btn-read-more`}>Read More</a>
            </div>
        </div>
        </>
      </div>
    )
  }
}

export default News_item
